import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

const baseurl = 'suratperingatan';
export default {
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(baseurl, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`suratperingatan/${obj.suratkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    calcPelunasan(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['pinjamankey', 'tglperhitungan'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/calcpelunasan${str}`;
                const { data } = await axios.get(url);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir',
                 'CustCode','CustName', 'collectability', 'kolektibiltas', 'no_kontrak','no_agreement',
                 'collector_id', 'model_pinjaman', 'nosurat', 'jenissuratkey', 'tgl1', 'tgl2','createby','statussp','delivery_status','expired_in_days','branch','LDSK','tgllast1', 'tgllast2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    listSPHistory(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['pinjamankey', 'suratkey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `${baseurl}/listSPHistory/${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer', 'collectability', 'no_kontrak', 'collector_id', 'model_pinjaman', 'nosurat', 'jenissuratkey', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'suratperingatan.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(suratkey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/detail/${suratkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    deliveryHistoryBySP(suratkey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/delivery-history-bysp/${suratkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    deletedeliveryHistoryBySP(historykey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`${baseurl}/delivery-history-bysp/${historykey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    ceknomorSP(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['nosurat'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`${baseurl}/ceknomorSP/${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    printPDF(obj) {
       return new Promise(async (resolve, reject) => {
            try {
                const keys = ['suratkey','pinjamankey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`${baseurl}/printpdf/${str}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    importdtxls(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                // const keys = ['sheetName', 'startRow', 'invoiceno', 'CustCode', 'CustName', 'Address1', 'npwp','npwp_name'];
                for (const key in obj) {
                    // if (keys.indexOf(key) >= 0 && obj[key]) {
                    fd.append(key, obj[key]);
                    // }
                }
                const { data } = await axios.post(`${baseurl}/importdtxls`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    savebulk(arr) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/savebulk`, arr);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    getworkflowSP() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/getworkflowSP`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    getSP(pinjamankey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/getSP/${pinjamankey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    sendsp(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(`${baseurl}/send-surat-peringatan`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    retursp(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(`${baseurl}/retur-surat-peringatan`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    followupsp(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(`${baseurl}/follow-up-surat-peringatan`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

}